import { Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useSEO } from "@/lib/useSEO";
import { api } from "@/lib/api";
import { faqs } from "@/lib/faqs";
import FAQAccordion from "@/components/FAQAccordion";
import { ArrowRight, HelpCircle } from "lucide-react";

export default function FAQ() {
  const [items, setItems] = useState(faqs);
  useEffect(() => {
    api.get("/page-config/faq").then(({ data }) => {
      if (Array.isArray(data?.items) && data.items.length) setItems(data.items);
    }).catch(() => {});
  }, []);
  useSEO({
    title: "FAQ — Online Boxing Coach & Virtual Boxing Lessons | Better Through Boxing",
    description: "Frequently asked questions about online boxing coaching with Coach Chris Persaud — how Zoom sessions work, equipment needed, the BTB Basics Program, pricing, scheduling, and more.",
    path: "/faq",
    keywords: ["online boxing coach FAQ", "virtual boxing lessons questions", "zoom boxing coaching how it works", "boxing coach for beginners", "BTB program FAQ"],
  });

  return (
    <div className="App relative">
      <SiteHeader />
      <main data-testid="faq-page">
        {/* Hero */}
        <section className="border-b border-[#27272A]">
          <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24">
            <div className="inline-flex items-center gap-2 text-[#FF331F] text-xs uppercase tracking-[0.3em] font-bold mb-4">
              <HelpCircle className="h-3.5 w-3.5" /> Frequently Asked Questions
            </div>
            <h1 className="font-display font-bold uppercase text-5xl md:text-7xl tracking-tight leading-[0.9] mb-6">
              The honest<br /><span className="text-[#FF331F]">answers.</span>
            </h1>
            <p className="text-zinc-300 leading-relaxed max-w-2xl text-base md:text-lg">
              How online boxing coaching actually works, what you need to get started, and everything you&apos;re probably wondering about the BTB Basics Program. Don&apos;t see your question? <Link to="/contact" className="text-[#FF331F] hover:underline">Ask Coach Chris directly</Link>.
            </p>
          </div>
        </section>

        {/* Accordion */}
        <section className="max-w-4xl mx-auto px-6 md:px-10 py-16">
          <FAQAccordion items={items} schemaId="faq-page-jsonld" />
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-6 md:px-10 py-20 text-center border-t border-[#27272A]">
          <h2 className="font-display uppercase text-3xl md:text-5xl tracking-tight leading-none mb-4">Still curious? Just train.</h2>
          <p className="text-zinc-400 max-w-xl mx-auto mb-8">The fastest way to know if online boxing coaching works for you is to do one session. 40 minutes, fully refundable peace of mind through the BTB Basics Program guarantee.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/book?package=virtual_40"><Button className="bg-[#FF331F] hover:bg-[#FF5242] text-white font-bold uppercase tracking-widest rounded-sm h-12 px-6" data-testid="faq-cta-book">Book a single session <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
            <Link to="/services"><Button variant="outline" className="border-zinc-700 text-white hover:bg-zinc-900 hover:text-white font-bold uppercase tracking-widest rounded-sm bg-transparent h-12 px-6">See all services</Button></Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
